// Shared table constants, styles, and pure helpers
// Used by both WageMapping and AddDeductTaxMapping modules.

export const EXCLUDED_ACCOUNT_TYPES = new Set([
    "accounts payable",
    "accounts receivable"
]);

export const filterAccounts = (accounts) => {
    if (!accounts) return [];
    return accounts.filter(acc =>
        !EXCLUDED_ACCOUNT_TYPES.has((acc.type || acc.AccountTypeName || "").toLowerCase())
    );
};

export const TABLE_STYLES = {
    input: {
        minWidth: 120,
        "& .MuiOutlinedInput-root": { height: "28px", fontSize: "12px", backgroundColor: "white" },
        "& .MuiOutlinedInput-input": { padding: "4px 8px", textAlign: "right" },
        "& .MuiOutlinedInput-root.Mui-disabled": { backgroundColor: "#f5f5f5 !important" },
        "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: "#000 !important", color: "#000 !important" }
    },
    dropdown: {
        minWidth: 150,
        "& .MuiFilledInput-root": {
            backgroundColor: "white", height: "28px", minHeight: "28px", paddingTop: "0px", paddingBottom: "0px",
            "&:hover": { backgroundColor: "white" }, "&.Mui-focused": { backgroundColor: "white" },
        },
        "& .MuiAutocomplete-input": { padding: "0px 8px !important", fontSize: "12px", height: "28px" },
        "& .MuiFilledInput-root.Mui-disabled": { backgroundColor: "#f5f5f5 !important" },
        "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: "#000 !important", color: "#000 !important" }
    },
    coaPopper: {
        width: "400px !important", maxWidth: "calc(100vw - 24px)"
    },
    tableHead: {
        "& .MuiTableCell-head": {
            height: "35px",
            minHeight: "35px",
            maxHeight: "35px",
            padding: "0 5px",
            boxSizing: "border-box",
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: "35px",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
        },
    },
};

export const renderCoaOption = (props, option, state) => {
    const { key, ...restProps } = props;
    const uniqueKey = `${option?.value ?? key ?? option?.label ?? "coa"}-${state?.index ?? ""}`;
    const label = option.label || "";
    if (option.value === "ADD_NEW") {
        return (
            <li key={uniqueKey} {...restProps} title={label} style={{ color: "#d32f2f", fontWeight: 500 }}>
                <span title={label}>{label}</span>
            </li>
        );
    }
    return (
        <li key={uniqueKey} {...restProps} title={label}>
            <span title={label} style={{ fontSize: 11, flex: 1, whiteSpace: "nowrap" }}>{label}</span>
            {option.type && (
                <span title={option.type} style={{ fontSize: 11, marginLeft: 8, whiteSpace: "nowrap", flexShrink: 0, fontWeight: 600, color: state?.selected ? "white" : "#6d6d6d" }}>
                    {option.type}
                </span>
            )}
        </li>
    );
};

export const formatAmountBlur = (value) => {
    let val = parseFloat(String(value).replace(/,/g, ""));
    if (isNaN(val) || String(value).trim() === "" || String(value).trim() === "-") val = 0;
    return val.toFixed(2);
};

